import { DataSetReference } from 'libs/end-to-end/src/types/databases/data-sets/data-set-reference';
import { DataSetVersionFull } from 'libs/end-to-end/src/types/databases/data-sets/data-set-version';
import React from 'react';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import { Modal } from 'apps/sigma2-ui/src/components/ui/Modal';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { useDataSetVersionSelectorModal } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetVersionSelectorModal';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';

export const DataSetVersionSelectorModal = ({
  dataSetReference,
  onComplete,
  onClose,
  organizationId,
  fullVersions,
}: {
  dataSetReference: DataSetReference | null;
  onComplete: (dataSetReference: DataSetReference) => void;
  onClose: () => void;
  organizationId: string;
  fullVersions: DataSetVersionFull[];
}) => {
  const {
    modalTitle,
    dataSetItems,
    dataSetVersionItems,
    isDataSetSelectable,
    continueButtonDisabled,
    continueButtonLabel,
    continueButtonBehavior,
    setSelectedDataSetVersion,
    selectedDataSetVersion,
    setSelectedDataSet,
    selectedDataSet,
    versionLabel,
  } = useDataSetVersionSelectorModal({
    dataSetReference,
    onComplete,
    organizationId,
    fullVersions,
  });

  return (
    <Modal show={true} onClose={onClose} title={modalTitle} scrollable={true}>
      <div className={'h-[40vh]'}>
        <Spacing size={'md'} direction={'vertical'}>
          <SelectBoxWithSearch
            type={'single'}
            list={dataSetItems}
            label={'Data Sets'}
            setSelected={setSelectedDataSet}
            selected={selectedDataSet ?? ''}
            disabled={!isDataSetSelectable}
            widthClass="w-full"
          />

          <SelectBoxWithSearch
            type={'single'}
            list={dataSetVersionItems}
            label={versionLabel}
            setSelected={setSelectedDataSetVersion}
            selected={selectedDataSetVersion ?? ''}
            disabled={!selectedDataSet}
            widthClass="w-full"
          />

          <Button
            behavior={continueButtonBehavior}
            text={continueButtonLabel}
            disabled={continueButtonDisabled}
          />
        </Spacing>
      </div>
    </Modal>
  );
};
